import { KYMW0D01Component } from './../kymw0d01/kymw0d01.component';
/**
 * 処理ログ件数表示クラス
 *
 * @export KYMW0D01Model
 * @class KYMW0D01Model
 */
export class KYMW0D01Model {

  kymw0D01Component: KYMW0D01Component;

  /**
   * 処理ログ一覧ヘッダー項目
   */
  public normalNum: string = <string>'';     // 正常件数
  public attentionNum: string = <string>'';  // 注意件数
  public abnormalNum: string = <string>'';   // 異常件数
  public updateNum: string = <string>'';     // ＤＢ更新件数
  public manageNum: string = <string>'';     // 処理件数
}
